(() => {
  const init = () => document.querySelectorAll('[data-aparu-trace]:not([data-ready])').forEach(root => {
    root.dataset.ready = 'true';
    const video = root.querySelector('video');
    const button = root.closest('.shopify-section').querySelector('.astra-film-toggle');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const poster = root.querySelector('picture img');
    if (poster.currentSrc) video.poster = poster.currentSrc;
    let pausedByUser = reduce.matches;
    let visible = false;
    let loaded = false;
    function sync() {
      const canPlay = visible && !document.hidden && !pausedByUser;
      if (canPlay && !loaded) {
        video.src = matchMedia('(max-width: 749px)').matches ? video.dataset.mobile : video.dataset.desktop;
        loaded = true;
      }
      if (canPlay) video.play().catch(() => { button.setAttribute('aria-label', 'Video abspielen'); });
      else video.pause();
    }
    video.addEventListener('play', () => {button.setAttribute('aria-label', 'Video pausieren');button.setAttribute('aria-pressed','true');});
    video.addEventListener('pause', () => {button.setAttribute('aria-label', 'Video abspielen');button.setAttribute('aria-pressed','false');});
    button.addEventListener('click', () => {pausedByUser = !video.paused;sync();});
    const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;sync();},{threshold:.15});
    observer.observe(root);
    document.addEventListener('visibilitychange', sync);
    reduce.addEventListener('change', () => {if (reduce.matches) pausedByUser = true;sync();});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

// Keep the theme-local menus reversible with pointer and keyboard.
(() => {
  const openMenus = () => document.querySelectorAll('.astra-nav-group details[open]');
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    openMenus().forEach(menu => {
      const containsFocus = menu.contains(document.activeElement);
      menu.open = false;
      if (containsFocus) {
        event.stopPropagation();
        menu.querySelector('summary').focus();
      }
    });
  }, true);
  document.addEventListener('click', event => {
    openMenus().forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
})();
